export const routeProps = {
  path: '/signup',
  exact: true,
};

export default () => routeProps;
